import { SaveButton } from '../common/button/save-button/SaveButton';

import './NoAccess.css';

export const NoAccess = ({ keycloak }) => {
  return (
    <div className="no-access">
      <p className="no-access-message">You do not have the correct permissions to access the ClinEase system.</p>
      <p className="no-access-message">Please contact Aurum IT to assign the correct LDAP groups to your account.</p>
      <SaveButton title="Return to Log In" onClick={keycloak.logout} color="#077187" />
    </div>
  );
};
